module.exports = __webpack_public_path__ + "img/BCH.69d1a07f.png";